<template>
  <span class="go-back">
    <v-tooltip
      :open-delay="tooltipDelay"
      bottom
    >
      <template v-slot:activator="{ on }">
        <v-btn
          v-bind="size"
          v-on="on"
          @click="goBack"
          class="my-2"
          color="primary"
        >
          <v-icon dark small left>mdi-arrow-left</v-icon>{{ $t('goBack.back') }}
        </v-btn>
      </template>
      <span>
        {{ $t('goBack.backTooltip') }}
      </span>
    </v-tooltip>
  </span>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    props: {
      btnSize: {
        type: String,
        default: 'lg'
      },
    },
    methods: {
      goBack() {
        return this.$router.go(-1);
      }
    },
    computed: {
      ...mapGetters({
        tooltipDelay: 'users/getTooltipDelay'
      }),
       size () {
        // const size = {xs:'x-small',sm:'small',lg:'large',xl:'x-large'}[this.$vuetify.breakpoint.name];
        const size = {xs:'x-small',sm:'small',lg:'large',xl:'x-large'}[this.btnSize];
        return size ? { [size]: true } : {}
      }
    }
  }
</script>

<style lang="scss" scoped>
  .go-back {
    display: flex;
    cursor: pointer;
  }
</style>